import { c as _c } from "react/compiler-runtime";
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { downloadFile, streamFetch } from '../utils';

/**
 * downloadName sets name of first download (after formatting, see function).
 * Subsequent downloads from expor history will use the name under which was saved in
 * the bucket by the backend export code. For consistency make sure these match.
 */
export const useStreamDownload = t0 => {
  const $ = _c(11);
  const {
    url,
    body,
    downloadName,
    headers,
    csvFormat: t1
  } = t0;
  const csvFormat = t1 === undefined ? false : t1;
  const queryClient = useQueryClient();
  let t2;
  if ($[0] !== body || $[1] !== headers || $[2] !== url) {
    t2 = async () => streamFetch({
      url,
      body,
      headers
    });
    $[0] = body;
    $[1] = headers;
    $[2] = url;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== csvFormat || $[5] !== downloadName || $[6] !== queryClient) {
    t3 = data => {
      downloadFile({
        data,
        downloadName,
        csvFormat
      });
      queryClient.invalidateQueries({
        queryKey: ["listExports"]
      });
    };
    $[4] = csvFormat;
    $[5] = downloadName;
    $[6] = queryClient;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = {
      mutationFn: t2,
      onSuccess: t3
    };
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return useMutation(t4);
};